import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import 'bootstrap/dist/css/bootstrap.min.css'
import './scss/theme.scss'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import { getLCP, getFID, getCLS } from 'web-vitals/base'

const container = document.getElementById('root')
const root = createRoot(container)
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_LIVE_KEY)

// getFID(console.log)

root.render(
  <React.StrictMode>
    <Elements stripe={stripePromise}>
    <App />
    </Elements>
  </React.StrictMode>
)
